const present = value => value !== undefined && value !== null && value !== ''
const keyOf = value => String(value)
const userIdOf = row => row?.user_id ?? row?.id ?? row?.value

export const filterWorkMemberOptions = (items = [], query = '') => {
  const keyword = String(query || '').trim().toLocaleLowerCase()
  if (!keyword) return items
  return items.filter(item => [
    item?.name,
    item?.text,
    item?.email,
    item?.organization_root_name,
    item?.organization_sub_name,
  ].some(value => String(value || '').toLocaleLowerCase().includes(keyword)))
}

export const reconcileWatcherIds = (assigneeId, watcherIds = []) => {
  const assigneeKey = present(assigneeId) ? keyOf(assigneeId) : ''
  const seen = new Set()
  return watcherIds.filter(id => {
    if (!present(id)) return false
    const key = keyOf(id)
    if (key === assigneeKey || seen.has(key)) return false
    seen.add(key)
    return true
  })
}

export const toggleWatcherId = (watcherIds = [], userId) => {
  if (!present(userId)) return reconcileWatcherIds('', watcherIds)
  const key = keyOf(userId)
  const current = reconcileWatcherIds('', watcherIds)
  return current.some(id => keyOf(id) === key)
    ? current.filter(id => keyOf(id) !== key)
    : [...current, userId]
}

export const splitWorkItemAssignments = (assignees = [], fallbackAssignee = null) => {
  const rows = Array.isArray(assignees) ? assignees.filter(Boolean) : []
  const assignee = rows.find(row => row.role === 'assignee' || !row.role) || fallbackAssignee || null
  const watchers = rows.filter(row => row.role === 'watcher')
  const assigneeId = userIdOf(assignee)
  return {
    assignee,
    assigneeId: present(assigneeId) ? assigneeId : '',
    watcherIds: reconcileWatcherIds(assigneeId, watchers.map(userIdOf)),
    watchers,
  }
}

export const buildWorkItemAssignments = (assigneeId, watcherIds = []) => [
  ...(present(assigneeId) ? [{ user_id: assigneeId, role: 'assignee', notify_enabled: true }] : []),
  ...reconcileWatcherIds(assigneeId, watcherIds).map(userId => ({
    user_id: userId,
    role: 'watcher',
    notify_enabled: true,
  })),
]

export const changeWorkItemAssignee = (item = {}, assigneeId) => ({
  ...item,
  default_assignee_id: assigneeId,
  watcher_ids: reconcileWatcherIds(assigneeId, item.watcher_ids || []),
})

export const buildChangedWorkItemAssignments = (item = {}, changes = {}) => {
  const hasAssignee = Object.prototype.hasOwnProperty.call(changes, 'assigneeId')
  const hasWatchers = Object.prototype.hasOwnProperty.call(changes, 'watcherIds')
  const assigneeId = hasAssignee
    ? changes.assigneeId
    : item.default_assignee_id || item.assignee?.user_id || item.assignee?.id || ''
  const watcherIds = hasWatchers ? changes.watcherIds : item.watcher_ids || []
  return buildWorkItemAssignments(assigneeId, watcherIds)
}
